import { useState } from "react";

import { Header } from "./components/Header";
import { MoreSheet } from "./components/MoreSheet";
import { TabBar, type TabId } from "./components/TabBar";
import { CalendarView } from "./views/CalendarView";
import { DeliveriesView } from "./views/Deliveries";
import { InventoryView } from "./views/Inventory";
import { PlansView } from "./views/Plans";
import { ReferenceView } from "./views/Reference";
import { TodayView } from "./views/Today";
import { TraysView } from "./views/Trays";
import { YieldView } from "./views/Yield";
import { tokens } from "./styles/theme";

export function App() {
  const [tab, setTab] = useState<TabId>("today");
  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <div
      style={{
        minHeight: "100vh",
        paddingBottom: "104px",
        background: tokens.page,
      }}
    >
      <Header tab={tab} />
      <main
        style={{
          maxWidth: "960px",
          margin: "0 auto",
          padding: "8px 20px 32px",
        }}
      >
        {tab === "today" && <TodayView />}
        {tab === "trays" && <TraysView />}
        {tab === "calendar" && <CalendarView />}
        {tab === "plans" && <PlansView onNavigateToday={() => setTab("today")} />}
        {tab === "deliveries" && <DeliveriesView />}
        {tab === "inventory" && <InventoryView />}
        {tab === "yield" && <YieldView />}
        {tab === "reference" && <ReferenceView />}
      </main>
      <TabBar tab={tab} onTab={setTab} onOpenMore={() => setMoreOpen(true)} />
      <MoreSheet
        open={moreOpen}
        activeTab={tab}
        onClose={() => setMoreOpen(false)}
        onPick={setTab}
      />
    </div>
  );
}
